import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import { TabComponent, TabsComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisitions-tabs',
  templateUrl: './requisitions-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, TabComponent, TabsComponent, TranslatePipe],
})
export class RequisitionsTabsComponent {
  public readonly offersCount = input<number>(0);
  public readonly hiresCount = input<number>(0);
  public readonly openingsCount = input<number>(0);
  public readonly attachmentsCount = input<number>(0);
  public readonly notesCount = input<number>(0);

  public get hiresTabCounter(): string {
    return `${this.hiresCount()}/${this.openingsCount()}`;
  }
}
